<template>
  <div class="container help">
    <div class="img_wrap">
      <img src="../../assets/img/help1.jpg" alt />
    </div>
    <home :ishome="0"></home>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import home from "../common/home.vue";
import opendata from "../common/opendata.vue";
import axios from "axios";
import { httpJsonp } from "../../../../api/base";

export default {
  data() {
    return {
      status: false,
      type: null,
      openid: null,
      loginWesuitInfo: null,
      sign: null,
      userid:'lianghongwei',
    };
  },
  components: {
    home,
    opendata
  },
  computed: {
    ...mapGetters({})
  },
  watch: {
    // loginWesuitInfo(cVal) {
    //   if (cVal) {
    //     this.getSign();
    //   }
    // },
    // sign(cVal) {
    //   if (cVal) {
    //     this.checkJsApi();
    //   }
    // }
  },
  created() {
      let _this = this;
    this.type = this.$route.query.type || "userName";
    this.openid =
      this.$route.query.openid || "f34e6d5f7c489aa81addf37414bf63fb";
    // this.WxRecord();
     new WxRecord(
        function (){
            _this.status = true;
            console.log('通讯录组件调用完毕')
        }
     );
  },
  methods: {
    WxRecord() {
      new WxRecord(() => {
        let _this = this;
        _this.getWesuitUserInfo();
      });
    },
    getWesuitUserInfo() {
      let _this = this;
      // let url = '/casback/api/fe/v1/private/j/loginWesuitInfo"';
      let url =
        "https://apps.test.care001.cn/acas/backend/api/fe/v1/private/j/loginWesuitInfo";
      axios.get(url).then(res => {
        console.log("getWesuitUserInfo res", res);
        if (res.data && res.data.errno === 0) {
          _this.loginWesuitInfo = res.data.body;
          this.userid = _this.loginWesuitInfo.wesuit.suiteId
        }
      });
    },
    getSign() {
      var url =
          window.location.href.indexOf("ddguanhuai") === -1
            ? "https://mp.test.care001.cn/weixin/wxqy_js_share_package.php"
            : "https://mp.ddguanhuai.com/weixin/wxqy_js_share_package.php",
        sendData = {
          agentConfig: 1,
          url: location.href.split("#")[0]
        };

      sendData.qyCorpId = this.loginWesuitInfo.wesuit.qyCorpId;
      sendData.suiteId = this.loginWesuitInfo.wesuit.suiteId;

      httpJsonp(url, sendData, (error, res) => {
        console.log("getSign res", res);
        if (res && res.errno == 0) {
          this.sign = res.body;
        }
      });
    },
    checkJsApi() {
      let _this = this;
      wx.checkJsApi({
        jsApiList: ["selectExternalContact"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function(res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          console.log("checkJsApi res", res);
          if (res.checkResult.selectExternalContact) {
            console.log("通讯录组件权限正常");
            _this.agentConfig();
          } else {
            console.log("通讯录组件权限异常");
          }
        }
      });
    },
    agentConfig() {
      let _this = this;
      wx.agentConfig({
        corpid: _this.loginWesuitInfo.wesuit.qyCorpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        // agentid: _this.loginWesuitInfo.wesuit.suiteId, // 必填，企业微信的应用id （e.g. 1000247）
        agentid: _this.loginWesuitInfo.wesuit.agentId,
        timestamp: _this.sign.timestamp, // 必填，生成签名的时间戳
        nonceStr: _this.sign.nonceStr, // 必填，生成签名的随机串
        signature: _this.sign.signature, // 必填，签名，见附录1
        jsApiList: ["selectExternalContact"], //必填
        success: function(res) {
          console.log("agentConfig success", res);
          // 回调
          _this.status = true;
        },
        fail: function(res) {
          console.log("agentConfig fail", res);
          if (res.errMsg.indexOf("function not exist") > -1) {
            alert("版本过低请升级");
          }
        }
      });
    }
  },
  mounted() {}
};
</script>